<template lang="pug">
el-dropdown.map_dropdown(
  placement="bottom-start" trigger="click" ref="dropDownCtn"
)
  el-button.map_button(
    :icon="icon" :style="{'color': titleShow == '高级筛选' ? '' : '#FF3973'}"
  ) {{ titleShow }}
  el-dropdown-menu.map_box_dropdown(slot="dropdown")
    li
      el-radio-group(v-model="radio")
        el-radio(:label="1") 屏幕数量>=
          el-input-number(
            @focus="radio = 1"
            v-model="numS" :min="0" :disabled="radio == 2"
            step-strictly :controls="false")
        el-radio(:label="2") 屏幕推荐>=
          el-input-number(
            @focus="radio = 2"
            v-model="numR" :min="0" :max="100" :disabled="radio == 1"
            step-strictly :controls="false")
      .media
        img.fl(src="../../../assets/snType.png")
        span.title 屏幕类型
        MultiChoose.multi(:list="screenTypes" v-model="mediaTypes")
      div.tab_footer
        el-button.common_button(@click="handleClickCancle") 取消
        el-button.common_button--inverse(@click="handleClickSure") 确定
</template>

<script>
import MultiChoose from './MultiChoose.vue'
export default {
  name: 'MapDropdown',
  components: { MultiChoose },
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    icon: {
      type: String,
      default: 'iconfont icon-ditutoufang-gaojishaixuan'
    },
    placeholder: {
      type: String,
      default: '高级筛选'
    }
  },
  data() {
    return {
      titleShow: '',
      radio: 0,
      numS: -1,
      numR: null,
      screenTypes: [
        { value: 0, label: '梯内屏' },
        { value: 1, label: '梯外屏' }
      ],
      mediaTypes: []
    }
  },
  watch: {
    radio() {
      this.numS = ''
      this.numR = ''
    }
  },
  beforeDestroy() {
    this.$root.$off('mapSearchStart')
  },
  created() {
    this.titleShow = this.placeholder
    const advanceOpt = this.$store.state.bmap.advancedFilter
    this.numR = advanceOpt.recommendData
    this.numS = advanceOpt.screenNum
    this.mediaTypes = advanceOpt.mediaTypes
  },
  mounted() {
    this.$root.$on('mapSearchStart', () => {
      this.radio = 0
      this.numR = ''
      this.numS = ''
      this.mediaTypes = []
      this.getNameStr()
    })
  },
  methods: {
    handleClickSure() {
      if (this.radio - 0 < 1) {
        this.numS = 0
        this.numR = 0
      }
      this.$store.commit('setAdvancedFilter', {
        screenNum: this.numS || '',
        recommendData: this.numR || '',
        mediaTypes: this.mediaTypes
      })

      let data = this.$store.state.bmap.searchDetail
      if (!data || data.length == 0) {
        this.$refs.dropDownCtn.hide()
        return
      }

      this.getNameStr()

      let num = null
      if (this.radio === 1) num = this.numS
      if (this.radio === 2) num = this.numR
      const mTs = this.mediaTypes
      const snFilter = mTs.length > 0 && mTs.length != this.screenTypes.length
      const snTn = !mTs.length || mTs.indexOf(0) > -1
      const snTw = !mTs.length || mTs.indexOf(1) > -1
      this.$root.$emit('mapSeniorSift', { type: this.radio, curNum: num, snFilter, snTn, snTw })
      this.$refs.dropDownCtn.hide() // 隐藏弹窗
    },

    // 点击取消,各数据项重置
    handleClickCancle() {
      this.numS = ''
      this.numR = ''
      this.mediaTypes = []
      this.radio = 0
      this.getNameStr()
    },
    getNameStr() {
      let nameStr = ''
      if (this.radio > 0) {
        if (this.radio == 1 && this.numS > 0) nameStr += this.numS + '屏'
        if (this.radio == 2 && this.numR >= 0) nameStr += '≥' + this.numR + '%'
      }
      if (this.mediaTypes.length) {
        if (nameStr != '') nameStr += '; '
        if (this.mediaTypes.length != this.screenTypes.length) {
          nameStr += this.screenTypes.filter(el => this.mediaTypes.indexOf(el.value) > -1).map(el => el.label).join(';')
        }
      }
      this.titleShow = nameStr || '高级筛选'
    }
  }
}
</script>

<style lang="scss" scoped>
.media {
  img {
    float: left;
    width: 14px;
    position: relative;
    top: 8px;
    margin-right: 10px;
  }
  .title {
    display: inline-block;
    margin-right: 20px;
  }
  .multi {
    display: inline-block;
    width: calc(100% - 103px);
  }
}
.el-dropdown-menu {
  padding: 15px 10px;
  width: 320px;
  .el-radio {
    width: 100%;
    margin-bottom: 15px;
    margin-right: 0;
    &+.el-radio {
      margin-left: 0;
    }
    .el-input-number {
      margin-left: 5px;
      ::v-deep > span {
        display: none;
      }
    }
  }
}
.tab_footer {
  box-shadow: 0 -1px 0 0 #e9e9e9;
  margin-top: 15px;
  padding-top: 15px;
  text-align: center;
  .el-button + .el-button {
    margin-left: 20px;
  }
}
</style>
